import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlanLimitError } from '../../models/enforcement.model';

@Component({
  selector: 'app-plan-limit-banner',
  templateUrl: './plan-limit-banner.component.html',
  styleUrls: ['./plan-limit-banner.component.scss'],
  standalone: false
})
export class PlanLimitBannerComponent {
  @Input() error: PlanLimitError | null = null;
  @Input() compact = false;
  @Output() dismissed = new EventEmitter<void>();
}
